import {coreApi} from './core'

export const invoiceService = {
    async getInvoices(params) {
        return await coreApi.get('invoice/', {params})
    },
    searchByDate: async (params) => await coreApi.get('invoice/search', {params}),
    create: async (data) => await coreApi.post('invoice', data),
    update: async (data) => await coreApi.put('invoice', data),
    delete: async (id) => await coreApi.delete(`invoice/${id}`),
    paginate: async (offset) => await coreApi.get(`invoice/${offset}`)
}